module.exports = "/_next/static/images/img-sm-only-2dd5cb64274805c8a2a6fd1335c7170b.jpg";